// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"87430c47","196":"136f057d","373":"758a0e02","410":"66817eb9","818":"e203fd14","966":"c2ab0d7d"}[chunkId] + ".chunk.css";
};